import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./cadastro.css";
import Imagens from "../../../components/IMAGESCOMPONENT/ImageComponent";

function Cadastro() {

  const [consultandoCnpj, setConsultandoCnpj] = useState(false);
  const [cnpjConsultado, setCnpjConsultado] = useState("");
  const [dadosLiberados, setDadosLiberados] = useState(false);
  const [mensagemCnpj, setMensagemCnpj] = useState("");

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [sucesso, setSucesso] = useState(false);

  const [form, setForm] = useState({
    nomecliente: "",
    razaosocial: "",
    email: "",
    fone: "",
    fone2: "",
    endereco: "",
    numero: "",
    bairro: "",
    cidade: "",
    estado: "",
    cep: "",
    pais: "Brasil",
    complemento: "",
    pontoref: "",
    cpf: "",
    cgc: "",
    inscestadual: ""
  });

  async function buscarCep(valor) {

    const cep = valor.replace(/\D/g, "");

    setForm((old) => ({
      ...old,
      cep
    }));

    if (cep.length !== 8) {
      return;
    }

    try {

      const response =
        await fetch(
          `https://viacep.com.br/ws/${cep}/json/`
        );

      const data =
        await response.json();

      if (!data.erro) {

        setForm((old) => ({
          ...old,
          endereco: data.logradouro || "",
          bairro: data.bairro || "",
          cidade: data.localidade || "",
          estado: data.uf || ""
        }));

      }

    } catch (err) {

      console.error(err);

    }

  }

  function alterarCampo(campo, valor) {

    setForm((old) => ({
      ...old,
      [campo]: valor
    }));

  }

  function formatarCPF(valor) {

    valor = valor.replace(/\D/g, "");

    valor = valor.substring(0, 11);

    valor = valor.replace(
      /(\d{3})(\d)/,
      "$1.$2"
    );

    valor = valor.replace(
      /(\d{3})(\d)/,
      "$1.$2"
    );

    valor = valor.replace(
      /(\d{3})(\d{1,2})$/,
      "$1-$2"
    );
    return valor;
  }

  function formatarCNPJ(valor) {

    valor = valor.replace(/\D/g, "");

    valor = valor.substring(0, 14);

    valor = valor.replace(
      /^(\d{2})(\d)/,
      "$1.$2"
    );

    valor = valor.replace(
      /^(\d{2})\.(\d{3})(\d)/,
      "$1.$2.$3"
    );

    valor = valor.replace(
      /\.(\d{3})(\d)/,
      ".$1/$2"
    );

    valor = valor.replace(
      /(\d{4})(\d)/,
      "$1-$2"
    );
    return valor;
  }

  async function handleSubmit(e) {

    e.preventDefault();
    setLoading(true);
    try {

      const response =
        await fetch(
          "https://app.eliandroalimentos.com.br/api/novocadastro/criar",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(form)
          }
        );
      if (!response.ok) {
        throw new Error();
      }
      setSucesso(true);
    } catch {
      alert(
        "Não foi possível enviar sua solicitação de cadastro."
      );
    } finally {
      setLoading(false);
    }
  }




  async function consultarCNPJ(cnpj) {

    if (cnpj.length !== 14) return;

    if (cnpj === cnpjConsultado) return;

    try {

      setConsultandoCnpj(true);

      const response = await fetch(
        `https://brasilapi.com.br/api/cnpj/v1/${cnpj}`
      );

      const data = await response.json();

      console.log("BrasilAPI:", data);

      const cepFormatado = data.cep
        ? data.cep.replace(/^(\d{5})(\d{3})$/, "$1-$2")
        : "";

      setForm((old) => ({
        ...old,

        cgc: formatarCNPJ(data.cnpj || ""),

        nomecliente: data.nome_fantasia || "",

        razaosocial: data.razao_social || "",

        inscestadual: data.inscricao_estadual || old.inscestadual,

        cep: cepFormatado,

        endereco: `${data.descricao_tipo_de_logradouro || ""} ${data.logradouro || ""}`.trim(),

        numero: data.numero || "",

        bairro: data.bairro || "",

        cidade: data.municipio || "",

        estado: data.uf || "",

        pais: "Brasil",
      }));


      setMensagemCnpj("");

      setDadosLiberados(true);

      setCnpjConsultado(cnpj);

    } catch (err) {

      console.error(err);


      setDadosLiberados(true);

    } finally {

      setConsultandoCnpj(false);

    }
  }


  function verificarCNPJ() {

    if (!dadosLiberados) {

      setMensagemCnpj("Primeiro preencha o CNPJ.");

      setTimeout(() => {
        setMensagemCnpj("");
      }, 3000);

      return false;
    }

    return true;
  }


  if (sucesso) {

    return (

      <div className="cadastro-wrapper">
        <div className="cadastro-card cadastro-sucesso">
          <img
            src={Imagens.Logo}
            alt=""
            style={{
              width: 170,
              marginBottom: 30
            }}
          />
          <h2>
            Cadastro enviado com sucesso!
          </h2>
          <p>
            Sua solicitação de cadastro foi enviada para análise.
          </p>
          <p>
            Entraremos em contato pelo telefone informado caso seja necessário enviar mais informações.
          </p>
          <p>
            Avisaremos assim que seu cadastro estiver pronto.
          </p>
          <p>

            <strong>

              Obs.: Para realizar o login e efetuar compras será necessário aguardar a aprovação do cadastro.

            </strong>

          </p>


          <div className="cadastro-sucesso-botoes">


            <button
              className="cadastro-button"
              onClick={() => navigate("/")}
            >
              Voltar para o site
            </button>

          </div>
        </div>
      </div>
    );

  }



  return (

    <div className="cadastro-wrapper">
      <div className="cadastro-card">
        <div className="cadastro-brand">

          <img
            src={Imagens.Logo}
            alt="Logo"
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          />
          {mensagemCnpj && (
            <div className="mensagem-cnpj">
              {mensagemCnpj}
            </div>
          )}

        </div>

        <form
          className="cadastro-form"
          onSubmit={handleSubmit}
        >


          <h3 className="form-section">
            Dados do Cliente
          </h3>

          <div className="form-grid">
            <div className="mobile-row">
              <div className="input-group mobile-left">
                <label>CNPJ</label>
                <input
                  value={form.cgc}
                  onChange={(e) => {

                    const valor = formatarCNPJ(e.target.value);

                    alterarCampo("cgc", valor);

                    const somenteNumeros = valor.replace(/\D/g, "");

                    if (somenteNumeros.length === 14) {
                      consultarCNPJ(somenteNumeros);
                    } else {
                      setDadosLiberados(false);
                      setCnpjConsultado("");
                    }

                  }}
                />
              </div>

              <div className="input-group mobile-right">
                <label>CPF</label>
                <input
                  value={form.cpf}
                  onChange={(e) =>
                    alterarCampo(
                      "cpf",
                      formatarCPF(e.target.value)
                    )
                  }
                />
              </div></div>

            <div className="input-group">
              <label>Nome Fantasia</label>

              <input
                readOnly={!dadosLiberados}
                onClick={() => !dadosLiberados && verificarCNPJ()}
                value={form.nomecliente}
                onChange={(e) =>
                  alterarCampo("nomecliente", e.target.value)
                }
                required
              />
            </div>

            <div className="input-group">
              <label>Razão Social</label>

              <input
                readOnly={!dadosLiberados}
                onClick={() => !dadosLiberados && verificarCNPJ()}
                value={form.razaosocial}
                onChange={(e) =>
                  alterarCampo("razaosocial", e.target.value)
                }
              />
            </div>

            <div className="input-group">
              <label>Inscrição Estadual</label>

              <input
                readOnly={!dadosLiberados}
                onClick={() => !dadosLiberados && verificarCNPJ()}
                value={form.inscestadual}
                onChange={(e) =>
                  alterarCampo("inscestadual", e.target.value)
                }
              />
            </div>

            <div className="input-group">
              <label>Email</label>

              <input
                type="email"
                readOnly={!dadosLiberados}
                onClick={() => !dadosLiberados && verificarCNPJ()}
                value={form.email}
                onChange={(e) =>
                  alterarCampo("email", e.target.value)
                }
                required
              />
            </div>
            <div className="mobile-row">
              <div className="input-group mobile-left">
                <label>Telefone</label>
                <input
                  value={form.fone}
                  onChange={(e) =>
                    alterarCampo("fone", e.target.value)
                  }
                  required
                />
              </div>

              <div className="input-group mobile-right">
                <label>Telefone 2</label>
                <input
                  value={form.fone2}
                  onChange={(e) =>
                    alterarCampo("fone2", e.target.value)
                  }
                />
              </div></div>

          </div>
          <h3 className="form-section">
            Endereço
          </h3>

          <div className="form-grid">

            <div className="input-group">
              <label>CEP</label>

              <input
                readOnly={!dadosLiberados}
                onClick={() => !dadosLiberados && verificarCNPJ()}
                value={form.cep}
                onChange={(e) => buscarCep(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <label>Endereço</label>

              <input
                readOnly={!dadosLiberados}
                onClick={() => !dadosLiberados && verificarCNPJ()}
                value={form.endereco}
                onChange={(e) =>
                  alterarCampo("endereco", e.target.value)
                }
              />
            </div>
            <div className="mobile-row">
              <div className="input-group mobile-left">
                <label>Número</label>
                <input
                  value={form.numero}
                  onChange={(e) =>
                    alterarCampo("numero", e.target.value)
                  }
                />
              </div>

              <div className="input-group mobile-right">
                <label>Complemento</label>
                <input
                  value={form.complemento}
                  onChange={(e) =>
                    alterarCampo("complemento", e.target.value)
                  }
                />
              </div></div>

            <div className="input-group">
              <label>Bairro</label>

              <input
                readOnly={!dadosLiberados}
                onClick={() => !dadosLiberados && verificarCNPJ()}
                value={form.bairro}
                onChange={(e) =>
                  alterarCampo("bairro", e.target.value)
                }
              />
            </div>

            <div className="input-group">
              <label>Cidade</label>

              <input
                readOnly={!dadosLiberados}
                onClick={() => !dadosLiberados && verificarCNPJ()}
                value={form.cidade}
                onChange={(e) =>
                  alterarCampo("cidade", e.target.value)
                }
              />
            </div>

            <div className="input-group mobile-left">
              <label>Estado</label>
              <input
                value={form.estado}
                onChange={(e) =>
                  alterarCampo("estado", e.target.value)
                }
              />
            </div>

            <div className="input-group mobile-right">
              <label>País</label>
              <input
                value={form.pais}
                onChange={(e) =>
                  alterarCampo("pais", e.target.value)
                }
              />
            </div>

            <div className="input-group">
              <label>Ponto de Referência</label>

              <input
                readOnly={!dadosLiberados}
                onClick={() => !dadosLiberados && verificarCNPJ()}
                value={form.pontoref}
                onChange={(e) =>
                  alterarCampo("pontoref", e.target.value)
                }
              />
            </div>

          </div>

          <button
            className="cadastro-button"
            disabled={loading}
          >
            {loading
              ? "Enviando..."
              : "Solicitar Cadastro"}
          </button>
        </form>


        <div className="cadastro-footer">

          <span>
            Já possui cadastro?
          </span>
          <a
            href="/"
          >
            Voltar para o login
          </a>
        </div>
      </div>
    </div>

  );

}

export default Cadastro;